/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_SnowInputs */

const en_ui_weather_snow = /** @type {(inputs: Ui_Weather_SnowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snow`)
};

const de_ui_weather_snow = /** @type {(inputs: Ui_Weather_SnowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnee`)
};

/**
* | output |
* | --- |
* | "Snow" |
*
* @param {Ui_Weather_SnowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_snow = /** @type {((inputs?: Ui_Weather_SnowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_SnowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_snow(inputs)
	return de_ui_weather_snow(inputs)
});